import { useState, useCallback, useMemo } from 'react';
export const defaultTemplateData = new Map([
  [
    'summit',
    {
      title: '大会论坛',
      desc: '适用于大会论坛、讲座论坛、发布会等大型活动，虚拟场地满足多会场的举办形式',
      img: '/activity-frontend_image/create-activity/template-forum.png',
      preview: {
        title: '大会论坛',
        desc: '适用于大会论坛、讲座论坛、发布会等大型活动，虚拟场地满足多会场的举办形式，同时支持嘉宾邀请、多日程、多票种的活动组织能力',
        recommendList: ['audience', 'shedule', 'ticket', 'registeration', 'market'],
        image: '/activity-frontend_image/create-activity/preview-forum.png',
      },
    },
  ],
  [
    'salon',
    {
      title: '研讨沙龙',
      desc: '适用于学术研讨、讲座沙龙、分享交流等活动，参会者在活动中可实现深度研讨和交流',
      img: '/activity-frontend_image/create-activity/template-salon.png',
      preview: {
        title: '研讨沙龙',
        desc: '适用于学术研讨、讲座沙龙、分享交流等活动，参会者在活动中可实现深度研讨和交流，支持嘉宾一键邀请、多票种报名等活动组织能力',
        recommendList: ['audience', 'ticket', 'registeration', 'market'],
        image: '/activity-frontend_image/create-activity/preview-salon.png',
      },
    },
  ],
  [
    'training',
    {
      title: '培训课程',
      desc: '适用于教学培训、咨询课程等活动，参与者在活动中学习、聆听、与讲师互动',
      img: '/activity-frontend_image/create-activity/template-train.png',
      preview: {
        title: '培训课程',
        desc: '适用于教学培训、咨询课程等活动，参与者在活动中学习、聆听和互动，支持多日程管理、多票种报名等活动组织能力',
        recommendList: ['shedule', 'ticket', 'registeration', 'playback', 'market'],
        image: '/activity-frontend_image/create-activity/preview-train.png',
      },
    },
  ],
  [
    'custom',
    {
      title: '自定义活动',
      desc: '支持自由、灵活地组织活动，满足多种场景的活动需要',
      img: '',
    },
  ],
]);
export interface PreviewData {
  title: string;
  desc: string;
  recommendList: any[];
  image: string;
}
export const templateModuleMap = new Map([
  [
    'audience',
    {
      icon: 'icon-pre-audience',
      title: '活动嘉宾',
      desc: '上传活动嘉宾的头像、介绍和头衔',
      iconColor: '#F9A500',
    },
  ],
  [
    'ticket',
    {
      icon: 'icon-pre-ticket',
      title: '门票管理',
      desc: '设置门票种类、价格和数量',
      iconColor: '#2894FF',
    },
  ],
  [
    'registeration',
    {
      icon: 'icon-pre-registeration',
      title: '报名页装修',
      desc: '设置报名页样式，支持经典样式、高级定制',
      iconColor: '#F37E5A',
    },
  ],
  [
    'market',
    {
      icon: 'icon-pre-market',
      title: '虚拟场地',
      desc: '设置直播大厅，支持清晰稳定的直播体验',
      iconColor: '#637CFF',
    },
  ],
  [
    'playback',
    {
      icon: 'icon-pre-playback',
      title: '回放管理',
      desc: '开启活动回放，回顾课程内容',
      iconColor: '#F9A500',
    },
  ],
  [
    'shedule',
    {
      icon: 'icon-pre-shedule',
      title: '活动日程',
      desc: '设置各个日程的时间、场地、嘉宾和详情介绍',
      iconColor: '#32C09E',
    },
  ],
]);
export const useTemplateHooks = (chooseTemplate?: Function) => {
  const [chooseType, changeChooseType] = useState('');
  const [modalVisible, updateModalVisible] = useState(false);
  const dataKeyList = Array.from(defaultTemplateData.keys());
  const modalData: PreviewData = useMemo(
    () => defaultTemplateData?.get(chooseType)?.preview as PreviewData,
    [chooseType],
  );
  // 展示预览模版模块
  const preview = useCallback(
    (item: string) => {
      changeChooseType(item);
      updateModalVisible(true);
    },
    [chooseType, modalVisible],
  );

  // 关闭模版预览
  const closeModal = useCallback(() => {
    updateModalVisible(false);
  }, []);
  // 创建活动
  const choose = (item: string) => {
    closeModal();
    chooseTemplate?.(item);
  };
  return {
    modalVisible,
    chooseType,
    dataKeyList,
    modalData,
    choose,
    closeModal,
    preview,
  };
};
